import { render, staticRenderFns } from "./Withdrawal3.vue?vue&type=template&id=88cec376&"
import script from "./Withdrawal3.vue?vue&type=script&lang=js&"
export * from "./Withdrawal3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports